var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-chart" },
    [
      _c("doughnut-chart", {
        staticClass: "chart-frame",
        attrs: { "chart-data": _vm.chartData, options: _vm.options }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }